import { render, staticRenderFns } from "./SensorText.vue?vue&type=template&id=076b6706&scoped=true&"
import script from "./SensorText.vue?vue&type=script&lang=js&"
export * from "./SensorText.vue?vue&type=script&lang=js&"
import style0 from "./SensorText.vue?vue&type=style&index=0&id=076b6706&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076b6706",
  null
  
)

export default component.exports